module.exports = __webpack_public_path__ + "img/Bodice-Front-B4-Da-Eb.6ce37cc5.png";